import OutType from "../../enums/OutType.js";

// @see https://www.mlb.com/glossary/standard-stats/ground-into-double-play
// @see https://www.mlb.com/glossary/standard-stats/double-play
// @see https://www.mlb.com/glossary/standard-stats/triple-play

const classifiesAsMultipleOuts = function(outType) {
    switch (outType) {
        case OutType.DoublePlay.key:
        case OutType.TriplePlay.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsMultipleOuts;